// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="rating_arena.SpentUsdPerSeason"></bfg-chart>
    </div>
</div>

<rating-arena-season-table api-method="spent_usd_table"></rating-arena-season-table>
`;
// Exports
module.exports = code;